<template>
  <div class="tree-cont">
    <div class="tree">
      <div ref="treeWrap">
        <span @click="checkAll" style="cursor: pointer">select all</span> /
        <span style="cursor: pointer" @click="checkNone">select none</span>

        <ul class="target-tree" style="height: 360px; overflow: auto">
          <DynamicScroller
            :items="localTargets"
            :min-item-size="36"
            class="scroller"
          >
            <template v-slot="{ item, index, active }">
              <DynamicScrollerItem
                :item="item"
                :active="active"
                :data-index="index"
              >
                <li class="tree-item">
                  <div class="item parent" :class="[{ checked: item.checked }]">
                    <label
                      class="checkbox"
                      :class="[
                        {
                          checked: item.checked,
                          indeterminate: checkIndeterminate(item),
                        },
                      ]"
                    >
                      <input
                        type="checkbox"
                        v-model="item.checked"
                        @change="onCheck(item)"
                      />
                      <span></span>
                    </label>
                    <div class="name">{{ item.title }}</div>
                    <div class="resources" v-if="item.assets_count">
                      assets: {{ item.assets_count }}
                    </div>
                    
                    <button
                      class="btn btn-sm btn-icon collapse"
                      v-if="item.assets.length > 0"
                      @click="item.expand = !item.expand"
                    >
                      <i
                        class="vik"
                        :class="[
                          {
                            'vik-down': !item.expand,
                            'vik-up': item.expand,
                          },
                        ]"
                      ></i>
                    </button>
                  </div>

                  <el-collapse-transition>
                    <ul
                      v-if="item.assets && item.assets.length && item.expand"
                      style="padding-inline-start: 40px"
                    >
                      <li
                        class="tree-item"
                        v-for="asset in item.assets"
                        :key="asset.id"
                      >
                        <div class="item" :class="[{ checked: asset.checked }]">
                          <label
                            class="checkbox"
                            :class="[{ checked: asset.checked }]"
                          >
                            <input
                              type="checkbox"
                              v-model="asset.checked"
                              @change="onCheck(asset)"
                            />
                            <span></span>
                          </label>
                          <div class="info">
                            <div class="name">{{ asset.title }}</div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </el-collapse-transition>
                </li>
              </DynamicScrollerItem>
            </template>
          </DynamicScroller>
          <!-- 
          <li class="tree-item" v-for="scope in localTargets" :key="scope.hash">
            <div class="item parent" :class="[{ checked: scope.checked }]">
              <label
                class="checkbox"
                :class="[
                  {
                    checked: scope.checked,
                    indeterminate: checkIndeterminate(scope),
                  },
                ]"
              >
                <input
                  type="checkbox"
                  v-model="scope.checked"
                  @change="onCheck(scope)"
                />
                <span></span>
              </label>
              <div class="name">{{ scope.title }}</div>
              <div class="resources" v-if="scope.assets_count">
                assets: {{ scope.assets_count }}
              </div>
              <button
                class="btn btn-sm btn-icon collapse"
                v-if="scope.assets.length > 1"
                @click="scope.expand = !scope.expand"
              >
                <i
                  class="vik"
                  :class="[
                    {
                      'vik-down': !scope.expand,
                      'vik-up': scope.expand,
                    },
                  ]"
                ></i>
              </button>
            </div>
            <el-collapse-transition>
              <ul
                v-if="scope.assets && scope.assets.length && scope.expand"
                style="padding-inline-start: 40px"
              >
                <li
                  class="tree-item"
                  v-for="asset in scope.assets"
                  :key="asset.hash"
                >
                  <div class="item" :class="[{ checked: asset.checked }]">
                    <label
                      class="checkbox"
                      :class="[{ checked: asset.checked }]"
                    >
                      <input
                        type="checkbox"
                        v-model="asset.checked"
                        @change="onCheck(asset)"
                      />
                      <span></span>
                    </label>
                    <div class="info">
                      <div class="name">{{ asset.title }}</div>
                    </div>
                  </div>
                </li>
              </ul>
            </el-collapse-transition>
          </li>
          -->
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
export default {
  name: "TargetsTree",
  props: {
    assets: { type: Array },
    showAssets: { type: Boolean },
  },
  data() {
    return {
      localTargets: [],
      // checkedScopes: new Set(),
      // checkedAssets: new Set(),
    };
  },
  watch: {
    assets: function (n, o) {
      this.processTargets(n);
    },
  },
  computed: {
    localeEmptyText() {
      if (typeof this.emptyText === "undefined") {
        return this.t("i.tree.emptyText");
      } else {
        return this.emptyText;
      }
    },
  },
  methods: {
    onCheck(item) {
      console.log("on check", item);
      if (item.type === "scope") {
        console.log("onCheck scope");
        // this.localTargets[index].checked = true;
        if ("assets" in item) {
          for (var y = 0; y < item.assets.length; y++) {
            //this.localTargets[index].expand = true;
            item.assets[y].checked = item.checked;
          }
        }
      } else {
        // item is an asset elem
        for (let index in this.localTargets) {
          if (this.localTargets[index].id == item.scope_id) {
            if (this.checkScopeChecked(this.localTargets[index])) {
              this.localTargets[index].checked = true;
            } else {
              this.localTargets[index].checked = false;
            }
          }
        }
      }
      if (item.checked) {
        // this.checkedAssets.add(item.title);
      } else {
        // this.checkedAssets.delete(item.title);
      }
    },
    checkAll() {
      for (let index in this.localTargets) {
        this.localTargets[index].checked = true;
        if ("assets" in this.localTargets[index]) {
          for (var y = 0; y < this.localTargets[index].assets.length; y++) {
            this.localTargets[index].expand = true;
            this.localTargets[index].assets[y].checked = true;
          }
        }
      }
    },
    checkNone() {
      for (let index in this.localTargets) {
        this.localTargets[index].checked = false;
        if ("assets" in this.localTargets[index]) {
          for (var y = 0; y < this.localTargets[index].assets.length; y++) {
            this.localTargets[index].expand = false;
            this.localTargets[index].assets[y].checked = false;
          }
        }
      }
    },
    checkScopeChecked(scope) {
      let total = scope.assets.length;
      if (total < 1) return false;
      let checked = 0;
      for (var i = 0; i < scope.assets.length; i++) {
        if (scope.assets[i].checked) checked++;
      }
      console.log("checkScopeChecked", total, checked);
      return total == checked;
    },
    checkIndeterminate(scope) {
      let total = scope.assets.length;
      if (total < 1) return false;
      let checked = 0;
      for (var i = 0; i < scope.assets.length; i++) {
        if (scope.assets[i].checked) checked++;
      }
      return checked > 0 && total != checked;
    },
    getCheckedValues() {
      console.time();
      let params = { scopes: [], assets: [], all: false };
      // let v = Array.from(this.checkedAssets);
      for (let item of this.localTargets) {
        if (item.checked) {
          params.scopes.push(item.id);
        } else {
          if ("assets" in item) {
            for (let asset of item.assets) {
              if (asset.checked) params.assets.push(asset.id);
            }
          }
        }
      }
      /*
      this.localTargets.forEach((e) => {
        if (e.checked) {
          if (e.type == "scope") {
            params.scopes.push(e.hash);
          } else {
            params.assets.push(e.hash);
          }
        }
        if ("assets" in e) {
          e.assets.forEach((ec) => {
            if (ec.checked) {
              v.push(ec.title);
            }
          });
        }
      });
      */
      console.timeEnd();
      return params; // _.uniq(v);
    },
    processTargets(items) {
      // console.log("got items", items);
      let that = this;
      /*
      for (let checkedItem of this.checkedAssets.values()) {
        if (!this.treeHas(items, checkedItem)) {
          items.unshift({ checked: true, title: checkedItem });
        } else {
          // console.log("there is ", checkedItem);
        }
      }
     
      // check top level values
      for (var i = 0; i < items.length; i++) {
        if (that.checkedAssets.has(items[i].title)) {
          items[i].checked = true;
        }
        if ("assets" in items[i]) {
          for (var y = 0; y < items[i].assets.length; y++) {
            if (that.checkedAssets.has(items[i].assets[y].hash)) {
              items[i].expand = true;
              items[i].assets[y].checked = true;
            }
          }
        }
      }
       */
      this.localTargets = items;
    },
    treeHas(items, title) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].title == title) {
          return true;
        }
        if ("assets" in items[i]) {
          for (var y = 0; y < items[i].assets.length; y++) {
            if (items[i].assets[y].title == title) {
              return true;
            }
          }
        }
      }
      return false;
    },
  },
  mounted() {
    this.localTargets = _.clone(this.assets, true);
  },
};
</script>
<style>
.vue-recycle-scroller {
  position: relative;
}
.vue-recycle-scroller.direction-vertical:not(.page-mode) {
  overflow-y: auto;
}
.vue-recycle-scroller.direction-horizontal:not(.page-mode) {
  overflow-x: auto;
}
.vue-recycle-scroller.direction-horizontal {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.vue-recycle-scroller__slot {
  -webkit-box-flex: 1;
  -ms-flex: auto 0 0px;
  flex: auto 0 0;
}
.vue-recycle-scroller__item-wrapper {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}
.vue-recycle-scroller.ready .vue-recycle-scroller__item-view {
  position: absolute;
  top: 0;
  left: 0;
  will-change: transform;
}
.vue-recycle-scroller.direction-vertical .vue-recycle-scroller__item-wrapper {
  width: 100%;
}
.vue-recycle-scroller.direction-horizontal .vue-recycle-scroller__item-wrapper {
  height: 100%;
}
.vue-recycle-scroller.ready.direction-vertical
  .vue-recycle-scroller__item-view {
  width: 100%;
}
.vue-recycle-scroller.ready.direction-horizontal
  .vue-recycle-scroller__item-view {
  height: 100%;
}
.resize-observer[data-v-b329ee4c] {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  pointer-events: none;
  display: block;
  overflow: hidden;
  opacity: 0;
}
.resize-observer[data-v-b329ee4c] object {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}
.dynamic-scroller-demo,
.scroller {
  height: 100%;
}
.dynamic-scroller-demo {
  overflow: hidden;
}
.notice {
  padding: 24px;
  font-size: 20px;
  color: #999;
}
.message {
  display: flex;
  min-height: 32px;
  padding: 12px;
  box-sizing: border-box;
}
.avatar {
  flex: auto 0 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 12px;
}
.avatar .image {
  max-width: 100%;
  max-height: 100%;
  border-radius: 50%;
}
.index,
.text {
  flex: 1;
}
.text {
  max-width: 400px;
}
.index {
  opacity: 0.5;
}
.index span {
  display: inline-block;
  width: 160px;
  text-align: right;
}
.scroller {
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/internal/AssetsTree.vue